import { inject, Injectable } from '@angular/core';
import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {isNullOrEmpty} from '../../core/utils/common-functions';

@Pipe({
  name: 'advanceTaskPipe'
})
@Injectable()
export class AdvanceTaskPipePipe implements PipeTransform {

  constructor(
    private translateService: TranslateService
  ) {

  }

  transform(value: Map<string, any>, taskCodeMapping: any[], advanceTaskCodePipe: any[]): string {
    if (!value || !(value instanceof Map)) {
      return '';
    }
    let properties = '';
    value.forEach((obj, key) => {
      const objProperties = this.getPropertiesString(obj, advanceTaskCodePipe);
      const task = taskCodeMapping.find(x => x.value === key)?.label;
      properties += `${task}:\n${objProperties}\n\n`;
    });
    return properties.trim();
  }

  private getPropertiesString(obj: any, advanceTaskCodePipe: any): string {
    const properties = Object.entries(obj)
      .map(([propKey, propVal]) => {
        if (typeof propVal === 'object' && propVal !== null) {
          return `${this.getPropertiesString(propVal, advanceTaskCodePipe)}`;
        } else {
          const translateKey = this.translateService.instant(`ReceivingInstruction.AdvanceTaskMaintenance.Label.${propKey}`);
          const translateValue = this.mappingTaskCode(propKey, propVal, advanceTaskCodePipe, obj);
          return `${translateKey}: ${translateValue}`;
        }
      })
      .join(',\n');
    return properties;
  }

  private mappingTaskCode(propKey: any, propVal: any, advanceTaskCodePipe: any, obj: any): string {
    let result = propVal;
    switch (propKey) {
      case 'lockType':
        result = advanceTaskCodePipe.lockType.find((x: any) => x.value === propVal)?.value;
        break;
      case 'lockCode':
        if (obj['lockType'] == 'Vendor') {
          result = advanceTaskCodePipe.vendorNumberOptions.find((x: any) => x.value === propVal)?.label;
        }
        if (obj['lockType'] == 'Customer') {
          result = advanceTaskCodePipe.consigneeKeyOptions.find((x: any) => x.value === propVal)?.label;
        }
        break;
      case 'lockReason':
        result = advanceTaskCodePipe.lockReason.find((x: any) => x.value === propVal)?.label;
        break;
    }

    if (isNullOrEmpty(result)) {
      result = this.translateService.instant(`ReceivingInstruction.AdvanceTaskMaintenance.Undefined`);
    }
    return result;

  }

}
